export enum MutationQuery {
    UPSERT_ORDER = `
    mutation UpsertOrder($companyOrderInfo: CompanyOrderInfoInput!, $stylesColorsSizes: [ModelColorSizeInput!]!, $warehouseId: Int!, $companyId: Int!, $currentUserId: Int!) {
        upsertOrder(
            companyOrderInfo: $companyOrderInfo
            stylesColorsSizes: $stylesColorsSizes
            warehouseId: $warehouseId
            companyId: $companyId
            currentUserId: $currentUserId
        ) {
            success
            message
        }
    }
    `,
    UPDATE_ORDER_STATUS = `
    mutation UpdateOrderStatus($companyId: Int!, $currentUserId: Int!, $orderId: Int!, $orderStatusId: Int!) {
        updateOrderStatus(companyId: $companyId, currentUserId: $currentUserId, orderId: $orderId, orderStatusId: $orderStatusId) {
            success
            message
        }
    }
    `,
	DELETE_ORDER = `
    mutation DeleteOrder($companyId: Int!, $currentUserId: Int!, $orderId: Int!) {
        deleteOrder(orderId: $orderId, companyId: $companyId, currentUserId: $currentUserId) {
            success
            message
        }
    }
    `,
	EDIT_PHOTOGRAPHER = `
    mutation UpdatePhotographer($currentUserId: Int!, $companyId: Int!, $photographerId: Int!, $statusId: Int, $shotCost: Float, $maxItems: Int, $discountThreshold: Float, $discountPercentage: Float, $startDate: String, $endDate: String, $automaticRenewal: Boolean!, $brandIdCategoryId: [BrandIdCategoryIdInput!]!) {
        updatePhotographer(
            currentUserId: $currentUserId
            companyId: $companyId
            photographerId: $photographerId
            automaticRenewal: $automaticRenewal
            brandIdCategoryId: $brandIdCategoryId
            statusId: $statusId
            shotCost: $shotCost
            maxItems: $maxItems
            discountThreshold: $discountThreshold
            discountPercentage: $discountPercentage
            startDate: $startDate
            endDate: $endDate
        ) {
            success
            message
        }
    }
    `,
	UPDATE_TEMPLATE = `
    mutation UpdateTemplate($companyId: Int!, $currentUserId: Int!, $updateTemplate: UpdateTemplateInput) {
        updateTemplate(
            companyId: $companyId
            currentUserId: $currentUserId
            updateTemplate:$updateTemplate
        ) {
            success
            message
        }
    }
    `,
	DELETE_TEMPLATE = `
    mutation DeleteTemplate($companyId: Int!, $parentTemplateId: Int!, $currentUserId: Int!) {
        deleteTemplate(companyId: $companyId, parentTemplateId: $parentTemplateId, currentUserId: $currentUserId) {
            success
            message
        }
    }
    `,
	INSERT_STYLE_SHOTS_COMMENT = `
    mutation InsertStyleShotsComment($currentUserId: Int!, $orderId: Int!, $sizeGroupId: Int, $colorId: Int, $modelId: Int, $imgPath: String, $text: String, companyId: $companyId) {
        insertStyleShotsComment(
            currentUserId: $currentUserId
            orderId: $orderId
            sizeGroupId: $sizeGroupId
            colorId: $colorId
            modelId: $modelId
            imgPath: $imgPath
            text: $text
            companyId: $companyId
        ) {
            success
            message
        }
    }
    `,
	INSERT_ORDER_COMMENT = `
    mutation InsertOrderComment($currentUserId: Int!, $orderId: Int!, $text: String, $imgPath: String, companyId: $companyId) {
        insertOrderComment(
            currentUserId: $currentUserId
            orderId: $orderId
            text: $text
            imgPath: $imgPath
            companyId: $companyId
        ) {
            success
            message
        }
    }
    `,
	UPDATE_SHOT_STATUS = `
    mutation UpdateShotStatus($currentUserId: Int!, $shotIds: [Int!]!, $statusId: Int!, $comments: String!, $companyId: Int!) {
        updateShotStatus(
            userId: $currentUserId
            shotIds: $shotIds
            statusId: $statusId
            comments: $comments
            companyId: $companyId
        ) {
            success
            message
        }
    }
    `,
    RESHOOT_PRODUCT = `
    mutation ReshootProduct($currentUserId: Int!, $companyId: Int!, $modelId: Int!, $colorId: Int, $sizeGroupId: Int) {
        reshootProduct(
            currentUserId: $currentUserId
            companyId: $companyId
            modelId: $modelId
            colorId: $colorId
            sizeGroupId: $sizeGroupId
        ) {
            success
            message
        }
    }
    `,
    SET_DEFAULT_COLOR = `
    mutation SetDefaultColor($companyId: Int!, $modelId: Int!, $colorId: Int!) {
        setDefaultColor(companyId: $companyId, modelId: $modelId, colorId: $colorId) {
            success
            message
        }
    }
    `,
}
